module.exports = __webpack_public_path__ + "media/images/views/home/home-features-icon-monitoring-6e984c8c25625e1a790a8b7f2c01490b.png";